import React, { useCallback } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getPoliciesActivePullingVehicles } from '@verzekeringapp-mono/shared/src/state/selectors/policies'
import { getLicensePlate } from '@verzekeringapp-mono/shared/src/utils/policy_utils'
import Button from '~/components/Button'
import usePolicies from '@verzekeringapp-mono/shared/src/hooks/use_policies'
import { useParams } from 'react-router-dom'

const GenerateGreenCard = () => {
  const { policyNumber } = useParams<{ policyNumber: string }>()
  const policiesActivePullingVehicles = useAppSelector(
    getPoliciesActivePullingVehicles
  )

  const isLoading = useAppSelector(
    (state) => state.policies.isLoadingInsuranceCard
  )
  const { generateInsuranceCard } = usePolicies()

  const onVehiclePressed = useCallback((vehiclePolicyNumber: string) => {
    if (!policyNumber) {
      return
    }

    generateInsuranceCard(vehiclePolicyNumber, policyNumber).then((greencard) => {
      if (greencard && greencard.url) {
        window.open(greencard.url, '_blank', 'noopener,noreferrer')
      }
    })
  }, [policyNumber, generateInsuranceCard])

  if (!policyNumber) {
    return <>Er is iets fout gegaan</>
  }

  return (
    <ScreenWrapper>
      <div className='max-w-[50%] rounded bg-surface-page p-8'>
        <div className='flex flex-col gap-4'>
          <h1 className='text-2xl'>Verzekeringsbewijs genereren</h1>

          <div className='flex flex-col gap-4'>
            {policiesActivePullingVehicles.map((vehicle) => (
              <Button
                key={vehicle.policyNumber}
                isLoading={isLoading}
                onClick={() => {
                  onVehiclePressed(vehicle.policyNumber)
                }}
              >
                {getLicensePlate(vehicle.details) ?? ''}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </ScreenWrapper>
  )
}

export default GenerateGreenCard
